import { Typography } from "@mui/joy";
import Tooltip from "@mui/material/Tooltip";
// helpers
import { copyTextToClipboard } from "helpers";
import React from "react";

export default function CopyLabel({ label }) {
  const [hover, setHover] = React.useState(false);
  const [click, setClick] = React.useState(false);

  return (
    <Tooltip title={click ? "Copied!" : "Click to Copy"}>
      <Typography
        noWrap
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setClick(true);
          copyTextToClipboard(label);
        }}
        sx={{
          background: hover ? "rgba(155,155,155, 0.1)" : "rgba(33,150,243, 0)",
          cursor: "pointer",
        }}
      >
        {label}
      </Typography>
    </Tooltip>
  );
}
